export class UICorePlugin {}